import React, { useState, useEffect } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { Link } from 'react-router-dom';
import { db } from '../firebaseConfig';
import './MuultiStyle.css';

export default function FeaturedMuultiSpaces({
                                                 featuredNames = [
                                                     'TheWeb3Connection',
                                                     'MuultiSpace',
                                                     'GmBlockchain',
                                                     'Big_Quotes', // example – adjust these to real muultiName values
                                                 ],
                                                 title = 'Featured Muulti Spaces',
                                             }) {
    const [spaces, setSpaces] = useState([]);

    useEffect(() => {
        let isMounted = true;

        async function load() {
            if (!featuredNames.length) return;

            try {
                const trimmed = featuredNames.slice(0, 10);
                const usersRef = collection(db, 'users');
                const q = query(usersRef, where('muultiName', 'in', trimmed));
                const snap = await getDocs(q);
                if (!isMounted) return;

                // Map by muultiName for easy lookup
                const byName = new Map(
                    snap.docs.map((doc) => {
                        const d = doc.data();
                        const muultiName = d.muultiName;
                        return [
                            muultiName,
                            {
                                id: doc.id,
                                muultiName,
                                pageTitle: d.pageTitle || muultiName,
                                pageDescription: d.pageDescription || '',
                                profilePicUrl: d.profilePicUrl || '',
                            },
                        ];
                    })
                );

                // Build final list in the exact order of featuredNames
                // and always return 4 items (fallback “coming soon” cards if missing)
                const final = trimmed.slice(0, 4).map((name) => {
                    const existing = byName.get(name);
                    if (existing) return existing;

                    // Fallback card when user doc not found
                    return {
                        id: `missing-${name}`,
                        muultiName: name,
                        pageTitle: name,
                        pageDescription: 'Featured Muulti page coming soon.',
                        profilePicUrl: '',
                    };
                });

                setSpaces(final);
            } catch (e) {
                console.error('Failed loading featured:', e);
            }
        }

        load();
        return () => {
            isMounted = false;
        };
    }, [featuredNames]);

    return (
        <div className="featured-muulti-container">
            {title && <h2>{title}</h2>}

            <div className="featured-grid">
                {spaces.map((space) => (
                    <Link
                        key={space.id}
                        className="featured-card"
                        to={`/${space.muultiName}`}
                    >
                        {space.profilePicUrl ? (
                            <img
                                src={space.profilePicUrl}
                                alt={space.pageTitle}
                                className="featured-image"
                            />
                        ) : (
                            <div className="featured-placeholder" />
                        )}

                        <h3 className="featured-title">{space.pageTitle}</h3>
                        <p className="featured-desc">{space.pageDescription}</p>
                    </Link>
                ))}
            </div>
        </div>
    );
}
